import { IUser } from "../schemas/entity_set"
import { IAuthService } from "../authentication/auth_service"
import { MessageBox } from "../helpers/message_box"
import { Routes, AppServices, AngularServices } from '../helpers/config_keys';

interface IMenuItem {
    label: string;
    route: string;
    icon: string;
    header: boolean;
    privilege?: string;
    children?: IMenuItem[];
}

class MainCtrl {
    version: string;
    username: string;
    menuItems: Array<IMenuItem>

    static $inject = [AngularServices.Q, AngularServices.RootScope, AngularServices.State, AppServices.AuthService];

    constructor(private $q: angular.IQService,
        private $rootScope: any,
        private $state: angular.ui.IStateService,
        private authenticate: IAuthService) {
        this.setVersion()
        this.setUserName()
        this.setUserMenus()
        this.$rootScope.$state = this.$state;
    }

    buyCredit() {
        this.$state.go(Routes.TopUpRequest, { apikey: this.authenticate.currentUser.apiKey })
    }

    isLoggedIn() {
        this.setUserName()
        return this.authenticate.isLogin();
    }

    signOut() {
        this.authenticate.logOut().then((res) => {
            if (res.success) {
                this.$state.go(Routes.Login)
            }
        })
    }

    setVersion() {
        this.version = "1.2"
    }

    setUserName() {
        let user = this.authenticate.currentUser
        this.username = user ? user.name : ""
    }

    isAuthorize(privilege: string) {
        return this.authenticate.isAuthorize(privilege)
    }

    setUserMenus() {
        let menus: Array<IMenuItem> = [
            { label: "Dashboard", route: Routes.Dashboard, icon: "fa fa-dashboard", header: false },
            { label: "Message Portal", route: Routes.MessagePortal, icon: "fa fa-envelope", header: false },
            { label: "Address Book", route: Routes.Contacts, icon: "fa fa-book", header: false },
            { label: "Change Password", route: Routes.ChangePassword, icon: "fa fa-lock", header: false },
        ]

        this.menuItems = menus;
    }
}

export { MainCtrl }


// WEBPACK FOOTER //
// ./app/main/main_ctrl.ts